const CHAT_INPUT_PORTAL_CSS_VARIABLES = [
  '--streamlain-v2-input-background',
  '--streamlain-v2-layer-background-overlayPanel',
  '--streamlain-v2-layer-background-primary',
  '--streamlain-v2-layer-background-hoverOverlay',
  '--streamlain-v2-layer-insideBorder-border',
  '--streamlain-v2-layer-insideBorder-primaryBorder',
  '--streamlain-v2-icon-activated',
  '--streamlain-v2-icon-primary',
  '--streamlain-v2-icon-secondary',
  '--streamlain-v2-button-primary',
  '--streamlain-v2-text-primary',
  '--streamlain-v2-text-secondary',
  '--streamlain-v2-text-placeholder',
  '--streamlain-text-primary-color',
  '--streamlain-text-secondary-color',
  '--streamlain-border-color',
  '--streamlain-black-30',
  '--streamlain-error-color',
  '--streamlain-hover-color',
  '--streamlain-overlay-panel-shadow',
  '--streamlain-white',
];

const CHAT_HISTORY_PORTAL_MAX_WIDTH = 420;

function getChatPortalStyleFromSource(
  source: HTMLElement,
  width: number
): Record<string, string> {
  const computedStyle = getComputedStyle(source);
  const style: Record<string, string> = {
    '--streamlain-disclosure-overlay-width': `${Math.max(0, width)}px`,
  };

  for (const variableName of CHAT_INPUT_PORTAL_CSS_VARIABLES) {
    const value = computedStyle.getPropertyValue(variableName).trim();
    if (value) {
      style[variableName] = value;
    }
  }

  return style;
}

export function getChatInputPortalReferenceElement(
  host: HTMLElement,
  fallback: HTMLElement
): HTMLElement {
  return (
    host.closest<HTMLElement>('.chat-panel-composer-input-stack') ??
    host.closest<HTMLElement>('ai-chat-input') ??
    fallback
  );
}

export function getChatInputPortalContainer(
  _host: HTMLElement,
  explicitContainer: HTMLElement | null
): Element {
  return explicitContainer ?? document.body;
}

export function getChatInputPortalOverlayWidth(reference: HTMLElement): number {
  const referenceRect = reference.getBoundingClientRect();
  const viewportSafeWidth = Math.max(0, window.innerWidth - 32);
  return referenceRect.width > 0
    ? Math.min(referenceRect.width, viewportSafeWidth)
    : viewportSafeWidth;
}

export function getChatHistoryPortalBoundary(host: HTMLElement): Element {
  return (
    host.closest('[data-testid="chat-panel-messages-container"]') ??
    host.closest('ai-chat-messages') ??
    host.parentElement ??
    host
  );
}

export function getChatHistoryPortalOverlayWidth(
  host: HTMLElement,
  maxWidth = CHAT_HISTORY_PORTAL_MAX_WIDTH
): number {
  const boundaryRect =
    getChatHistoryPortalBoundary(host).getBoundingClientRect();
  const viewportSafeWidth = Math.max(0, window.innerWidth - 32);
  return boundaryRect.width > 0
    ? Math.min(maxWidth, boundaryRect.width, viewportSafeWidth)
    : Math.min(maxWidth, viewportSafeWidth);
}

export function getChatInputPortalStyle(
  host: HTMLElement,
  width: number
): Record<string, string> {
  const source = host.closest<HTMLElement>('ai-chat-input') ?? host;
  return getChatPortalStyleFromSource(source, width);
}

export function getChatHistoryPortalStyle(
  host: HTMLElement,
  width: number
): Record<string, string> {
  const source =
    host.closest<HTMLElement>('ai-chat-messages') ??
    host.closest<HTMLElement>(
      '[data-testid="chat-panel-messages-container"]'
    ) ??
    host;
  return getChatPortalStyleFromSource(source, width);
}
